class PageSearch {
  constructor() {
    this._init();
  }

  _init() {
    var links: NodeListOf<Element> = document.querySelectorAll(
      '[data-trigger="page-search-link"]'
    );
    var tabs: NodeListOf<Element> = document.querySelectorAll(
      '[data-trigger="page-search-results"]'
    );

    if (links && links.length > 0 && tabs && tabs.length > 0) {
      this.updateTabActive(tabs, links);
    }
  }

  updateTabActive(tabs: NodeListOf<Element>, links: NodeListOf<Element>) {
    links.forEach((link) => {
      link?.addEventListener('click', (e: Event) => {
        const linkElement = e.target as HTMLElement;
        const linkValue = linkElement?.getAttribute('data-link');
        if (linkElement && linkValue) {
          const tab = document.querySelector(`[data-tab="${linkValue}"]`);

          links.forEach((item) => item.classList.remove('active'));
          tabs.forEach((item) => item.classList.remove('active'));
          link.classList.add('active');
          tab?.classList.add('active');
        }
      });
    });
  }
}

export const pageSearch = new PageSearch();
